import { CustomerProjects } from 'src/app/projects/views/project-list/state/api/queries/projectsListQuery';
import { AssociatedCustomer, UserProjectAccess, Status, Role } from 'src/shared/types';

export const getUserStatusFromEnum = (status: string) => {
    switch (status) {
        case 'Active':
            return Status.SUCCESS;
        case 'Invited':
            return Status.WARNING;
        default:
            return Status.ERROR;
    }
};

export const checkIfCustomerAdmin = (customerList: AssociatedCustomer[], currentCustomerId: string) => {
    let isAdmin = false;
    customerList.some((customer: AssociatedCustomer) => {
        if (customer.roles?.includes(Role.CUSTOMER_ADMIN) && customer.customerId === currentCustomerId) isAdmin = true;
    });
    return isAdmin;
};

export const getUserRoleCount = (currentCustomerProjectIds: string[], userProjects: UserProjectAccess[]) => {
    const userRoles = new Set<Role>();
    userProjects.forEach(project => {
        if (currentCustomerProjectIds.includes(project.projectId)) {
            project.roles?.forEach(role => {
                userRoles.add(role);
            });
        }
    });
    return userRoles.size;
};

export const getProjectNameForProjectId = (currentCustomerProjects: CustomerProjects, projectId: string) => {
    return currentCustomerProjects.find(project => project.projectId === projectId)?.projectName.trim();
};
